function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "image (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.15,
    height: 28.555,
    viewBox: "0 0 31.15 28.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16397",
    d: "M8.112 162.092a4.86 4.86 0 0 1-4.6-3.311l-.045-.149a4.737 4.737 0 0 1-.225-1.407v-8.85L.1 158.886a2.948 2.948 0 0 0 2.066 3.576l20.07 5.375a2.976 2.976 0 0 0 .748.1 2.894 2.894 0 0 0 2.8-2.122l1.169-3.718zm0 0",
    transform: "translate(0 -139.378)",
    style: {
      fill: "#e0e0df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16398",
    d: "M151.916 69.684a2.6 2.6 0 1 0-2.6-2.6 2.6 2.6 0 0 0 2.6 2.6zm0 0",
    transform: "translate(-140.236 -60.598)",
    style: {
      fill: "#e0e0df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16399",
    d: "M108.034.492H88.565a3.25 3.25 0 0 0-3.245 3.245v14.277a3.25 3.25 0 0 0 3.245 3.245h19.469a3.25 3.25 0 0 0 3.245-3.245V3.737a3.25 3.25 0 0 0-3.245-3.245zm-19.469 2.6h19.469a.649.649 0 0 1 .649.649v9.214l-4.1-4.784a2.325 2.325 0 0 0-1.741-.8 2.269 2.269 0 0 0-1.734.819l-4.821 5.786-1.57-1.567a2.278 2.278 0 0 0-3.219 0l-3.582 3.581V3.737a.649.649 0 0 1 .649-.649zm0 0",
    transform: "translate(-80.129 -.492)",
    style: {
      fill: "#e0e0df"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.32c133b2bb3fc321a2f65ca90062318b.svg";
export { ForwardRef as ReactComponent };